import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setChosenLocationEmpty } from "../../api/xoicom.reducer";
import "../../style/components/IngredientList.css";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import IngredientCollapse from "./IngredientCollapse";

function IngredientListMobile({
  ingredientPreview,
  showIngredient,
  ingredientText,
  language,
}) {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const { buttonText } = ingredientText;

  useEffect(() => {
    if (ingredientPreview?.length === 1) {
      showIngredient(ingredientPreview[0]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ingredientPreview]);

  useEffect(() => {
    setTimeout(() => {
      ref?.current?.scrollIntoView({ behavior: "smooth" });
    }, 500);
  }, []);

  return (
    <div>
      <div ref={ref} className="ingredient-mobile">
        <div>
          {ingredientPreview.map((ingredient) => (
            <IngredientCollapse
              key={ingredient.id}
              ingredient={ingredient}
              onIngredientClick={() => showIngredient(ingredient)}
              language={language}
              mobile
              ingredientPreview={ingredientPreview}
            />
          ))}
        </div>
      </div>
      <div className="other-ingredient-controller-mobile clickable">
        <div
          className="ingredient-details-card ingredient-controller-label-mobile cap-r15"
          style={{ margin: "4px auto" }}
        >
          <div
            className="ingredient-controller-button"
            onClick={() => dispatch(setChosenLocationEmpty())}
          >
            <KeyboardArrowLeftRoundedIcon style={{ marginBottom: 2 }} />
            {buttonText.back}
          </div>
        </div>
      </div>
    </div>
  );
}

export default IngredientListMobile;
